module.exports = __webpack_public_path__ + "files/b149b7b18011bf6d2333fe73f24b3d30.png";